var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_3283_4248)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3283_4248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "url(#paint1_linear_3283_4248)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3283_4248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 19C47.9588 19 54 25.0661 54 32.5556C54 40.045 47.9588 46.1111 40.5 46.1111C33.0413 46.1111 27 40.045 27 32.5556C27 25.0661 33.0413 19 40.5 19ZM54 54.7189C54 58.3111 53.055 66.6817 46.6088 76.035L43.875 59.6667L47.0475 53.2956C44.955 53.0583 42.7612 52.8889 40.5 52.8889C38.2388 52.8889 36.045 53.0583 33.9525 53.2956L37.125 59.6667L34.3912 76.035C27.945 66.6817 27 58.3111 27 54.7189C18.9337 57.0911 13.5 61.3611 13.5 66.4444V80H67.5V66.4444C67.5 61.3611 62.1 57.0911 54 54.7189Z",
    fill: "url(#paint2_linear_3283_4248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_4248",
    x1: -19.5,
    y1: 0,
    x2: 90.1875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_4248",
    x1: -19.5,
    y1: 0,
    x2: 90.1875,
    y2: 92.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBCFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3283_4248",
    x1: 40.5,
    y1: 19,
    x2: 40.5,
    y2: 117.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleUser);
export default __webpack_public_path__ + "static/media/MaleUser.c3125888696c2654a1c9db3bb5d6a402.svg";
export { ForwardRef as ReactComponent };